// Round-trip time to a world's SpacetimeDB server, for the world picker. Only a hint for the player: the world's own
// latency display (in game) measures the real connection.

/** The server's HTTP ping endpoint for a world URI (ws/wss URIs map to http/https). */
export function pingUrl(uri: string): string {
  return `${uri.replace(/^ws(s?):\/\//i, 'http$1://').replace(/\/+$/, '')}/v1/ping`;
}

async function once(url: string, timeoutMs: number): Promise<number | null> {
  const abort = new AbortController();
  const timer = setTimeout(() => abort.abort(), timeoutMs);
  const start = performance.now();
  try {
    // no-cors: only the timing matters, so servers without CORS headers still answer.
    await fetch(url, { mode: 'no-cors', cache: 'no-store', signal: abort.signal });
    return performance.now() - start;
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}

/** Milliseconds, or null when the server didn't answer. The first request pays for DNS/TLS, so the best of three. */
export async function pingWorld(uri: string, timeoutMs = 3000): Promise<number | null> {
  const url = pingUrl(uri);
  let best: number | null = null;
  for (let i = 0; i < 3; i++) {
    const ms = await once(url, timeoutMs);
    if (ms === null) break;
    best = best === null ? ms : Math.min(best, ms);
  }
  return best === null ? null : Math.round(best);
}
